import { defineField, defineType } from "sanity";
import { contentFilterPreview } from "../../common/localization";
import { airNonAirFilter, locationFilter } from "../base";
import ctaButtons from "./ctaButtons/ctaButtons";
import { isPresent } from "../../utils/checks";

import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "featuredContentRow",
  type: "object",
  title: "Featured Content Row",
  fields: [
    {
      name: "image",
      title: "Image",
      type: "imageWithAlt"
    },
    {
      name: "imageSize",
      title: "Image Size",
      description: "If empty, the default is regular",
      type: "string",
      options: {
        list: [
          { title: "Regular", value: "regular" },
          { title: "Small", value: "small" }
        ]
      }
    },
    defineField({
      name: "title",
      type: "multilingualArrayText"
    }),
    {
      name: "description",
      type: "multilingualArrayBlockContent"
    },
    {
      ...ctaButtons,
      name: "link",
      validation: (Rule) => Rule.max(2)
    },
    {
      name: "ctaButtonsMobileOverride",
      title: "Override CTA Buttons on Mobile",
      description:
        "Use different CTA buttons on mobile devices (overrides the desktop CTA buttons)",
      type: "boolean"
    },
    {
      type: "ctaButtons",
      name: "ctaButtonsMobile",
      title: "CTA Buttons Mobile",
      options: {
        collapsible: true,
        collapsed: true
      },
      hidden: ({ parent }) => !parent?.ctaButtonsMobileOverride,
      validation: (Rule) =>
        Rule.custom((value: [], context) => {
          if ((context.parent as any)?.ctaButtonsMobileOverride) {
            if (!isPresent(value) || value.length === 0) {
              return "You must add at least one CTA button when override is enabled.";
            }
          }
          return true;
        })
    },
    {
      name: "locationFilters",
      title: "Location Filters",
      type: "array",
      of: [
        {
          type: locationFilter.name
        },
        {
          type: airNonAirFilter.name
        }
      ]
    }
  ],
  preview: {
    select: {
      title: "title",
      media: "image",
      locationFilters: "locationFilters"
    },
    prepare({ title, media, locationFilters }) {
      return {
        title: multilingualStringPreview(title),
        media,
        subtitle: contentFilterPreview(locationFilters)
      };
    }
  }
});
